export default __webpack_public_path__ + "static/media/auth_small_facebook.423c0281.svg";